module.exports = __webpack_public_path__ + "img/mastercard_logo.1055b8eb.svg";